interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOMeta({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage }: SEOMetaProps) {
  return null;
}

export function generateSEOMeta(pageType: string, extra?: Record<string, string>) {
  const baseTitle = '韩漫之家_免费韩漫在线阅读平台_高清下拉式韩漫全集_韩国漫画免费读';
  const baseDesc = '韩漫之家作为专业在线阅读平台，提供高清下拉式韩漫全集，真正实现韩国漫画免费读，让您尽情享受阅读乐趣。';
  const baseKeywords = '韩漫之家,免费韩漫,在线阅读平台,高清下拉式全集,韩国漫画免费读';

  switch (pageType) {
    case 'home':
      return {
        title: baseTitle,
        description: baseDesc,
        keywords: baseKeywords,
      };
    case 'category':
      return {
        title: `${extra?.categoryName || '分类'}_韩漫_${baseTitle}`,
        description: `韩漫之家提供海量${extra?.categoryName || ''}类韩国漫画免费在线阅读，高清下拉式全集，更新速度快，分类清晰，是您阅读${extra?.categoryName || ''}韩漫的最佳选择。`,
        keywords: `${extra?.categoryName || ''}韩漫,韩国漫画,${baseKeywords}`,
      };
    case 'article':
      return {
        title: `${extra?.title || '漫画详情'}_韩漫之家_免费韩漫在线阅读`,
        description: `免费在线阅读《${extra?.title || ''}》高清下拉式全集。${extra?.description || ''}`.slice(0, 160),
        keywords: `${extra?.title || ''},${extra?.category || ''}韩漫,韩国漫画,免费阅读,${baseKeywords}`,
      };
    case 'about':
      return {
        title: `关于我们_韩漫之家_免费韩漫在线阅读平台`,
        description: '了解韩漫之家——专业免费韩漫在线阅读平台。提供高清下拉式韩漫全集，品牌介绍、用户口碑与联系方式。',
        keywords: `关于韩漫之家,免费韩漫平台,${baseKeywords}`,
      };
    default:
      return {
        title: baseTitle,
        description: baseDesc,
        keywords: baseKeywords,
      };
  }
}